<template>
  <div>
    <a-modal
      :title="dataForm.id ? '编辑项目' : '新增项目'"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="handleOk"
      :keyboard="false"
      :maskClosable="false"
      @cancel="handleCancel"
      :getContainer="getContainer"
    >
      <a-form-model
        ref="ruleForm"
        :model="dataForm"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="项目名称" prop="name">
          <a-input v-model="dataForm.name" placeholder="请输入项目名称" />
        </a-form-model-item>
        <a-form-model-item label="项目地址" prop="address">
          <a-input v-model="dataForm.address" placeholder="请输入项目地址" />
        </a-form-model-item>
        <a-form-model-item label="负责人姓名" prop="own">
          <a-input v-model="dataForm.own" placeholder="请输入负责人姓名" />
        </a-form-model-item>
        <a-form-model-item label="负责人联系电话" prop="phone">
          <a-input
            v-model="dataForm.phone"
            placeholder="请输入负责人联系电话"
            type="number"
          />
        </a-form-model-item>
        <a-form-model-item label="项目logo" prop="logo">
          <a-upload
            name="file"
            :multiple="true"
            :file-list="fileList"
            :action="$store.state.config.baseURL + '/upload'"
            :remove="remove"
            @change="handleChange"
            @preview="preview"
          >
            <a-button> <a-icon type="upload" /> 点击上传 </a-button>
          </a-upload>
        </a-form-model-item>
        <!-- {{ dataForm.project_role_menu }} -->
        <a-form-model-item label="功能授权" prop="project_role_menu">
          <a-tree
            v-model="dataForm.project_role_menu"
            checkable
            :replace-fields="replaceFields"
            autoExpandParent
            selectable
            :tree-data="treeData"
            @check="onCheck"
          />
          <!-- {{ dataForm.project_role_menu }} -->
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { Userinfo } from "@/request/login";
import { addProject, editProject, projectInfo } from "@/request/sys";
export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
      fileList: [],
      treeData: [],
      replaceFields: { children: "children", title: "title", key: "id" },
      dataForm: {
        id: "",
        name: "", //项目名称
        address: "", //项目地址
        own: "", //
        phone: "", //联系电话
        logo: "", //logo
        project_role_menu: [],
      },
      bf: {},
      rules: {
        name: [
          { required: true, message: "请输入项目名称", trigger: "change" },
        ],
        logo: [
          { required: true, message: "请上传项目logo", trigger: "change" },
        ],
        project_role_menu: [
          {
            type: "array",
            required: true,
            message: "请分配项目功能权限",
            trigger: "change",
          },
        ],
      },
    };
  },
  beforeMount() {
    this.bf = JSON.parse(JSON.stringify(this.dataForm));
  },
  methods: {
    isArraySubset(subset, superset) {
      return subset.every((value) => superset.includes(value));
    },
    onCheck(checkedKeys, e) {
      // e.checkedNodes.forEach((v) => {
      //   let a = v.data.props.dataRef.children.map((m) => m.id);
      //   if (a.length > 0) {
      //     const is_ = this.isArraySubset(a, this.dataForm.project_role_menu);
      //     if (is_)
      //       this.dataForm.project_role_menu.splice(
      //         this.dataForm.project_role_menu.findIndex(
      //           (n) => n == v.data.props.dataRef.id
      //         ),
      //         1
      //       );
      //   }
      // });
    },
    init(id) {
      if (id) {
        this.dataForm.id = id;
        this.getInfo();
      }
      this.visible = true;
      Userinfo().then((res) => {
        this.treeData = res.data.role_menu;
      });
    },
    getInfo() {
      projectInfo(this.dataForm.id).then((res) => {
        this.dataForm = { ...res.data };
        this.fileList = [
          {
            url: res.data.logo,
            uid: "-1",
            name: res.data.logo,
            status: "done",
          },
        ];
      });
    },
    remove(e) {
      this.dataForm.logo = "";
    },
    handleOk(e) {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.confirmLoading = true;
          const fn = this.dataForm.id ? editProject : addProject;
          fn(this.dataForm)
            .then(() => {
              this.$message.success(
                this.dataForm.id ? "修改项目成功" : "新增项目成功"
              );
              this.handleCancel();
              this.$emit("ok");
              let a = setTimeout(() => {
                clearTimeout(a);
                this.confirmLoading = false;
              }, 500);
            })
            .finally(() => {
              let a = setTimeout(() => {
                clearTimeout(a);
                this.confirmLoading = false;
              }, 500);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleCancel(e) {
      console.log("Clicked cancel button");
      this.$refs.ruleForm.resetFields();
      this.dataForm = JSON.parse(JSON.stringify(this.bf));
      this.fileList = [];
      this.visible = false;
    },
    handleChange(info) {
      let fileList = [...info.fileList];
      fileList = fileList.slice(-1);
      fileList = fileList.map((file) => {
        if (file.response) {
          // Component will show file.url as link
          file.url = file.response.data.url;
          this.dataForm.logo = file.response.data.url;
        }
        return file;
      });

      this.fileList = fileList;
    },
    preview(e){
      this.$viewerApi({
        images: [e.url],
      });
    },
    onSelect(selectedKeys, info) {
      console.log("onSelect", info);
      // this.selectedKeys = selectedKeys;
    },
    getContainer(){
      return document.getElementById("bodyContnet")
    }
  },
};
</script>

<style></style>